import { SET_SELECTED_DATE } from 'redux/modules/slot-booking/actions/types';
import { CAROUSEL_START_POSITION } from 'constants/carouselSlidePosition';

export const setSelectedDate = (date, carouselStartPosition = CAROUSEL_START_POSITION) => ({
  type: SET_SELECTED_DATE,
  date,
  carouselStartPosition,
});
